import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/app.css'
import VueCookies from 'vue3-cookies'


const app = createApp(App);
app.use(store)
app.use(router)
app.use(VueCookies)
app.mount('#app')
